import React from 'react';
import styled from 'styled-components';
import Image from 'gatsby-theme-core/src/components/image';
import Button from 'gatsby-theme-core/src/components/button/index';

const LabelsGrid = styled.div`
  display: flex;
  align-items: center;
  gap: 1.5rem;
  flex-wrap: wrap;
`;

const Icon = styled.div`
  flex-shrink: 0;
  aspect-ratio: ${({ $height, $width }) => `${$width} / ${$height}`};
  ${({ $ratio }) => ($ratio < 1 ? 'height: 60px;' : 'width: 60px;')}
  background-image: url(${({ $icon }) => $icon});
  background-size: cover;
`;

const Labels = ({
  className,
  labels,
}) => (
  <div className={className}>
    <LabelsGrid>
      {labels.map(({
        id,
        alternativeImage,
        image,
        link,
      }) => {
        const img = alternativeImage || image;
        const ratio = img.width / img.height;
        return (
          <Button forceLinkOpenInNewTab wrapper to={link} key={id}>
            {img?.ext === '.svg' && (
              <Icon
                $icon={img.url}
                $width={img.width}
                $height={img.height}
                $ratio={ratio}
              />
            )}
            {img?.ext !== '.svg' && (
              <Image
                image={img}
                width={img.width}
                height={img.height}
              />
            )}
          </Button>
        );
      })}
    </LabelsGrid>
  </div>
);

export default styled(Labels)``;
